// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file search/search_responses.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { Chat } from '../chat/chat_model_pb';
import { file_chat_chat_model } from '../chat/chat_model_pb';
import type { User } from '../user/user_model_pb';
import { file_user_user_model } from '../user/user_model_pb';

/**
 * Describes the file search/search_responses.proto.
 */
export const file_search_search_responses: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Ch1zZWFyY2gvc2VhcmNoX3Jlc3BvbnNlcy5wcm90bxIUY29tLmdlbS5iZmYuY29udHJhY3QiXAoUR2xvYmFsU2VhcmNoUmVzcG9uc2USPAoHc3VjY2VzcxgBIAEoCzIpLmNvbS5nZW0uYmZmLmNvbnRyYWN0Lkdsb2JhbFNlYXJjaFN1Y2Nlc3NIAEIGCgR0eXBlIosBChNHbG9iYWxTZWFyY2hTdWNjZXNzEikKBXVzZXJzGAEgAygLMhouY29tLmdlbS5iZmYuY29udHJhY3QuVXNlchIpCgVjaGF0cxgCIAMoCzIaLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkNoYXQSEwoGY3Vyc29yGAMgASgJSACIAQFCCQoHX2N1cnNvckIYChRjb20uZ2VtLmJmZi5jb250cmFjdFABYgZwcm90bzM',
    [file_user_user_model, file_chat_chat_model]
  );

/**
 * @generated from message com.gem.bff.contract.GlobalSearchResponse
 */
export type GlobalSearchResponse = Message<'com.gem.bff.contract.GlobalSearchResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GlobalSearchResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.GlobalSearchSuccess success = 1;
         */
        value: GlobalSearchSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GlobalSearchResponse.
 * Use `create(GlobalSearchResponseSchema)` to create a new message.
 */
export const GlobalSearchResponseSchema: GenMessage<GlobalSearchResponse> =
  /*@__PURE__*/
  messageDesc(file_search_search_responses, 0);

/**
 * @generated from message com.gem.bff.contract.GlobalSearchSuccess
 */
export type GlobalSearchSuccess = Message<'com.gem.bff.contract.GlobalSearchSuccess'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.User users = 1;
   */
  users: User[];

  /**
   * @generated from field: repeated com.gem.bff.contract.Chat chats = 2;
   */
  chats: Chat[];

  /**
   * @generated from field: optional string cursor = 3;
   */
  cursor?: string;
};

/**
 * Describes the message com.gem.bff.contract.GlobalSearchSuccess.
 * Use `create(GlobalSearchSuccessSchema)` to create a new message.
 */
export const GlobalSearchSuccessSchema: GenMessage<GlobalSearchSuccess> =
  /*@__PURE__*/
  messageDesc(file_search_search_responses, 1);
